import styled from "styled-components";

export const ContainerUpload = styled.div`
  width: 425px;
`;
